import React from "react";
import Rules from "../../../../../config/rules";
import Grid from "@mui/material/Grid";
import {ValidatorForm} from "react-material-ui-form-validator";
import DateControlInput from "./DateControlInput";


const DateInput = (props) => {

    React.useEffect(() => {
        ValidatorForm.addValidationRule('isValidDate', Rules.isValidDate);
        return () => {
            ValidatorForm.removeValidationRule('isValidDate');
        }
    }, [props.value])

    let {
        displayCondition,
        validators,
        errorMessages,
        canBeBefore1950,
        ...rest
    } = props;

    // Init array if not set
    if (!validators) validators = [];
    if (!errorMessages) errorMessages = [];

    // Add date valid control in first position after required
    if (validators[0] === 'required') {
        // if first is required put at position 1 instead of 0
        validators.splice(1, 0, 'isValidDate');
        errorMessages.splice(1, 0, Rules.txtInvalidDate);
    } else {
        // else set as first position
        validators.reverse().push('isValidDate');
        validators.reverse();
        errorMessages.reverse().push(Rules.txtInvalidDate);
        errorMessages.reverse();
    }

    if (canBeBefore1950 !== true) {
        validators.push(Rules.reg('isAfter1950'));
        errorMessages.push(Rules.txtDateIsBefore1950);
    }

    // Prevent control to be triggered if the input is hidden
    return <div>
        {displayCondition !== false &&
            <DateControlInput validators={validators} errorMessages={errorMessages} {...rest}/>}
    </div>

}

export default DateInput;
